<template>
    <div>
        <van-nav-bar
                title="Información de trabajo"
                left-text=""
                right-text=""
                left-arrow
                @click-left="onClickLeft"
                @click-right="onClickRight"
        >
            <template #left>
                <van-icon name="arrow-left" color="#000000" />
                <span>Volver</span>
            </template>
        </van-nav-bar>
        <div class="apply_wrap" id="applywork">
            <div class="apply_banner">
                <!--<img src="../../assets/img/applyhead.png" />-->
            </div>
            <div class="apply_head">
                <div class="apply_hview">
                    <img src="../../assets/img/applyhead01.webp" />
                </div>
            </div>

            <div class="apply_topview">
                <div class="apply_top">
                    Ya desbloqueó el monto. Rellene información para aumenterlo.
                </div>
            </div>
            <div class="apply_formview">

                <div class="bank_conttop">
                    <div class="bank_ctitems" @click="onCheckitem('1')">
                        <div class="bank_ctitem" :class="isCheck == '1' ? 'bank_ctitem_active' : ''">
                            <div class="bank_ctileft">
                                <template v-if="bankoneval == null">
                                    Elija el tipo de cuenta
                                </template>
                                <template v-else>
                                    {{bankoneval.name}}
                                </template>
                            </div>
                            <div class="bank_ctiright">
                                <div class="bank_ctirview"><img src="../../assets/img/comf_rparrow.png" alt=""></div>
                            </div>
                        </div>
                    </div>

                    <!--<div class="bank_ctitems" @click="onCheckitem('2')">
                        <div class="bank_ctitem" :class="isCheck == '2' ? 'bank_ctitem_active' : ''">
                            <div class="bank_ctileft">
                                <template v-if="banktwoval == null">
                                    Fuente de ingresos
                                </template>
                                <template v-else>
                                    {{banktwoval.name}}
                                </template>
                            </div>
                            <div class="bank_ctiright">
                                <div class="bank_ctirview"><img src="../../assets/img/comf_rparrow.png" alt=""></div>
                            </div>
                        </div>
                    </div>-->

                    <div class="bank_ctitems" @click="onCheckitem('3')">
                        <div class="bank_ctitem" :class="isCheck == '3' ? 'bank_ctitem_active' : ''">
                            <div class="bank_ctileft">
                                <template v-if="bankthrval == null">
                                    Frecuencia de recibir el ingreso
                                </template>
                                <template v-else>
                                    {{bankthrval.name}}
                                </template>
                            </div>
                            <div class="bank_ctiright">
                                <div class="bank_ctirview"><img src="../../assets/img/comf_rparrow.png" alt=""></div>
                            </div>
                        </div>
                    </div>

                    <template v-if="bankthrval">
                        <template v-if="bankthrval.id == 3 || bankthrval.id == 4">
                            <div class="bank_ctitems" @click="onCheckitem('4')">
                                <div class="bank_ctitem" :class="isCheck == '4' ? 'bank_ctitem_active' : ''">
                                    <div class="bank_ctileft">
                                        <template v-if="bankfurval == null">
                                            Elija 1er día de cobro
                                        </template>
                                        <template v-else>
                                            {{bankfurval.name}}
                                        </template>
                                    </div>
                                    <div class="bank_ctiright_new">
                                        <div class="bank_ctirview_new"><img src="../../assets/img/comf_rparrow02.png" alt=""></div>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="bankthrval.id == 2">
                            <div class="bank_ctitems" @click="onCheckitem('5')">
                                <div class="bank_ctitem" :class="isCheck == '5' ? 'bank_ctitem_active' : ''">
                                    <div class="bank_ctileft">
                                        <template v-if="bankfivval == null">
                                            Elija 1ndo día de cobro
                                        </template>
                                        <template v-else>
                                            {{bankfivval}}
                                        </template>
                                    </div>
                                    <div class="bank_ctiright_new">
                                        <div class="bank_ctirview_new"><img src="../../assets/img/comf_rparrow02.png" alt=""></div>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="bankthrval.id == 1">
                            <div class="bank_ctitems" @click="onCheckitem('5')">
                                <div class="bank_ctitem" :class="isCheck == '5' ? 'bank_ctitem_active' : ''">
                                    <div class="bank_ctileft">
                                        <template v-if="bankfivval == null">
                                            Elija 1ndo día de cobro
                                        </template>
                                        <template v-else>
                                            {{bankfivval}}
                                        </template>
                                    </div>
                                    <div class="bank_ctiright_new">
                                        <div class="bank_ctirview_new"><img src="../../assets/img/comf_rparrow02.png" alt=""></div>
                                    </div>
                                </div>
                            </div>

                            <div class="bank_ctitems" @click="onCheckitem('6')">
                                <div class="bank_ctitem" :class="isCheck == '6' ? 'bank_ctitem_active' : ''">
                                    <div class="bank_ctileft">
                                        <template v-if="banksixval == null">
                                            Elija 2ndo día de cobro
                                        </template>
                                        <template v-else>
                                            {{banksixval}}
                                        </template>
                                    </div>
                                    <div class="bank_ctiright_new">
                                        <div class="bank_ctirview_new"><img src="../../assets/img/comf_rparrow02.png" alt=""></div>
                                    </div>
                                </div>
                            </div>

                        </template>
                    </template>


                    <!--<div class="bank_ctitems" @click="onCheckitem('4')">
                        <div class="bank_ctitem" :class="isCheck == '4' ? 'bank_ctitem_active' : ''">
                            <input v-model="bank_no" class="bank_code" type="number" />
                        </div>
                    </div>-->
                </div>

                <div class="bank_contmiddle">
                    <div class="bank_contmleft">
                        <div class="bank_contmlview">
                            <img src="../../assets/img/apply_useicon.png" />
                        </div>
                    </div>
                    <div class="bank_contmright">
                        <p>
                            Superapoyomax mantiene su información personal privada y segura durante todo el proceso.
                        </p>
                    </div>
                </div>


                <div class="bank_contdown">
                    <van-button round color="#19A95C" block style="height: 1.111111rem;" @click.stop="onConfirm">
                        <span style="font-weight: 500;">Enviar</span>
                    </van-button>
                </div>

            </div>
        </div>

        <template v-show="bankoneShow">
            <van-action-sheet
                    v-model="bankoneShow"
                    :actions="actionsOne"
                    cancel-text="Cancelar"
                    description="Nivel de su ingreso"
                    close-on-click-action
                    @select="onSelectOne"
            />
        </template>

        <template v-show="banktwoShow">
            <van-action-sheet
                    v-model="banktwoShow"
                    :actions="actionsTwo"
                    cancel-text="Cancelar"
                    description="Fuente de ingresos"
                    close-on-click-action
                    @select="onSelectTwo"
            />
        </template>

        <template v-show="bankthrShow">
            <van-action-sheet
                    v-model="bankthrShow"
                    :actions="actionsThr"
                    cancel-text="Cancelar"
                    description="Frecuencia de recibir el ingreso"
                    close-on-click-action
                    @select="onSelectThr"
            />
        </template>

        <template v-show="bankfurShow">
            <van-action-sheet
                    v-model="bankfurShow"
                    :actions="actionsFur"
                    cancel-text="Cancelar"
                    description="Elija el día de paga"
                    close-on-click-action
                    @select="onSelectFur"
            />
        </template>

        <template v-show="bankfivShow">
            <div id="bank_fiv">
                <van-calendar v-model="bankfivShow"
                              title="Día de cobro"
                              color="#19A95C"
                              :min-date="minDate"
                              :max-date="maxDate"
                              :show-mark="isFalse"
                              :show-subtitle="isFalse"
                              :show-confirm="isFalse"
                              @select="onCalendarSelect"
                />
            </div>
        </template>

        <template v-show="banksixShow">
            <div id="bank_six">
            <van-calendar v-model="banksixShow"
                          title="Día de cobro"
                          color="#19A95C"
                          :min-date="minDate"
                          :max-date="maxDate"
                          :show-mark="isFalse"
                          :show-subtitle="isFalse"
                          :show-confirm="isFalse"
                          @select="onCalendarSelectSix"
            />
            </div>
        </template>
    </div>
</template>

<script>

    import axios from 'axios'
    import { getTimezoneName, getUserIp } from '@/utils/commonParams';
    import { loadingShow, loadingHide } from '@/utils/loading'
    import { getAccessToken } from '@/utils/auth';

    import { updateApplyWork } from '@/api/apply';
    import { getLoanInfo } from '@/api/loan';

    import { Toast } from 'vant';
    import $ from 'jquery';

    export default{
        data() {
            return {
                activeNav: 'living',
                isCheck: '1',
                bank_no: null,
                bankmessage: null,
                bankoneShow: false,
                bankoneval: null,
                actionsOne: [
                    { id: '1', name: '0～3,000 MXN'},
                    { id: '2', name: '3,000~6,000 MXN' },
                    { id: '3', name: '6,000~9,000 MXN' },
                    { id: '4', name: '9,000~12,000 MXN' },
                    { id: '5', name: '12,000~15,000 MXN' },
                    { id: '6', name: '15,000+ MXN' },
                ],
                banktwoShow: false,
                banktwoval: null,
                actionsTwo: [
                    { id: '1', name: 'su'},
                    { id: '2', name: 'Los padres'},
                    { id: '3', name: 'amigos'},
                    { id: '4', name: 'otros'},
                ],
                bankthrShow: false,
                bankthrval: null,
                actionsThr: [
                    { id: '1', name: 'Quincenal'},
                    { id: '2', name: 'Mensual'},
                    { id: '3', name: 'Semanal'},
                    { id: '4', name: 'Catorcenal'},
                ],
                bankfurShow: false,
                bankfurval: null,
                actionsFur: [
                    { id: '1', name: 'Lunes'},
                    { id: '2', name: 'Martes'},
                    { id: '3', name: 'Miércoles'},
                    { id: '4', name: 'Jueves'},
                    { id: '5', name: 'Viernes'},
                    { id: '6', name: 'Sábado'},
                    { id: '7', name: 'Domingo'},
                ],
                bankfivShow: false,
                bankfivval: null,
                banksixShow: false,
                banksixval: null,
                isFalse: false,
                minDate: null,
                maxDate: null,
            }
        },
        created() {
            const today = new Date();
            const year = today.getFullYear();
            const month = today.getMonth() + 1; // getMonth() 返回的月份是从0开始的，所以需要加1
            const day = today.getDate();

            let month_days = 30;

            if(month == 1 || month == 3 || month == 5 || month == 7 || month == 8 || month == 10 || month == 12){
                month_days = 31
            } else if(month == 4 || month == 6 || month == 9 || month == 11){
                month_days = 30
            } else if(month == 2){
                if(this.isLeapYear(year)){
                    month_days = 29
                } else {
                    month_days = 28
                }
            }

            this.minDate = new Date(year, month, 1);
            this.maxDate = new Date(year, month, month_days);

        },
        mounted() {

        },
        methods: {
            onClickLeft() {
                this.$router.back();
            },
            onClickRight() {

            },

            onCheckitem(type){
                this.isCheck = type;
                if(type == '1'){
                    this.bankoneShow = true;
                } else if(type == '2'){
                    this.banktwoShow = true;
                } else if(type == '3'){
                    this.bankthrShow = true;
                } else if(type == '4'){
                    this.bankfurShow = true;
                } else if(type == '5'){
                    this.bankfivShow = true;
                } else if(type == '6'){
                    this.banksixShow = true;
                }
            },
            isLeapYear(year) {
                if((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0) {
                    return true;
                } else {
                    return false;
                }
            },
            onSelectOne(item) {
                console.log(item)
                this.bankoneval = item;
            },
            onSelectTwo(item) {
                this.banktwoval = item;
            },
            onSelectThr(item) {
                this.bankthrval = item;
            },
            onSelectFur(item) {
                this.bankfurval = item;
            },
            onCalendarSelect(day) {
                let useDate = day.getDate();
                this.bankfivval = useDate;
                this.bankfivShow = false;
            },
            onCalendarSelectSix(day) {
                let useDate = day.getDate();
                this.banksixval = useDate;
                this.banksixShow = false;
            },
            async getCommomParams(params) {
                let current_step = '1004';
                /*if(current_step == '1004'){ //个人信息
                    window.location.replace('./applyperson.html?' + homeUrlParams)
                } else if(current_step == '1001'){ //工作信息
                    window.location.replace('./applywork.html?' + homeUrlParams)
                } else if(current_step == '1005'){ //身份证信息
                    window.location.replace('./applyidcard.html?' + homeUrlParams)
                } else if(current_step == '1010'){ //绑定银行卡
                    window.location.replace('./applybank.html?' + homeUrlParams)
                } else if(current_step == '1006'){ //活体
                    window.location.replace('./livingverify.html?' + homeUrlParams)
                }*/

                /*if(current_step == '1004') {
                    this.$router.push({
                        path: '/loanpage/applyperson'
                    })
                }*/

                let { monthly_income, income_source } = params;

                let time_zone = getTimezoneName();
                console.log(time_zone);
                let ip = await getUserIp()
                console.log(ip)

                let postData = {
                    zzm_yya_hqb: getAccessToken(),
                    aaa_off_csl: '111',
                    qcj_gbs_chg: monthly_income,
                    fkv_ymb_tzh: income_source
                };

                let headerParams = {
                    'ad-justad-id': localStorage.getItem("adjust_id"),
                    'ad-justad-j': '',
                    'ad-justad-idfv': '',
                };

                loadingShow();
                updateApplyWork(postData, {
                    'bwd-irh-lnf': time_zone,
                    'xfo-plp-van': ip,
                    ...headerParams
                }).then(res => {
                    console.log(res)
                    if (res.ci == 200) {
                        let useData = res.da;
                        console.log(JSON.parse(useData))
                        if (useData) {
                            let useDataJSON = JSON.parse(useData);
                            let { bqr_rle_jto } = useDataJSON;
                            // 1001 工作信息
                            // 1002 联系人信息
                            // 1004 个人信息
                            // 1005 身份信息
                            // 1006 活体认证
                            // 1010 绑定银行卡
                            if(bqr_rle_jto == 8001){
                                loadingHide()
                                this.$router.replace({
                                    path: '/loanpage/applywork'
                                })
                            } else if(bqr_rle_jto == 8002){
                                loadingHide()
                                this.$router.replace({
                                    path: '/loanpage/applycontacts'
                                })
                            } else if(bqr_rle_jto == 8004){
                                loadingHide()
                                this.$router.replace({
                                    path: '/loanpage/applyperson'
                                })
                            } else if(bqr_rle_jto == 8005){
                                loadingHide()
                                this.$router.replace({
                                    path: '/loanpage/applyidcard'
                                })
                            } else if(bqr_rle_jto == 8006){
                                loadingHide()
                                this.$router.replace({
                                    path: '/loanpage/livingverify'
                                })
                            } else if(bqr_rle_jto == 7106){
                                loadingHide()
                                this.$router.replace({
                                    path: '/loanpage/livingverify'
                                })
                            } else if(bqr_rle_jto == 8010){
                                loadingHide()
                                this.$router.replace({
                                    path: '/loanpage/applybank'
                                })
                            } else if(bqr_rle_jto == 7101){
                                this.gotoStatus()
                                // this.$router.replace({
                                //     path: '/loanpage/applyhome'
                                // })
                            } else if(bqr_rle_jto == 7102){
                                this.gotoStatus()
                                // this.$router.replace({
                                //     path: '/loanpage/applyhome'
                                // })
                            } else if(bqr_rle_jto == 7105){
                                this.gotoStatus()
                                // this.$router.replace({
                                //     path: '/loanpage/applyhome'
                                // })
                            } else if(bqr_rle_jto == 8110){
                                this.gotoStatus()
                                // this.$router.replace({
                                //     path: '/loanpage/applyhome'
                                // })
                            }
                         }
                    } else {
                        loadingHide()
                        Toast(res.ms);
                    }
                }, error => {
                    loadingHide()
                })

            },
            async gotoStatus() {
                let _this = this;
                const login_token = getAccessToken();
                console.log(login_token)
                if(login_token){ //已经登录
                    console.log('已登录11111')
                    let time_zone = getTimezoneName();
                    console.log(time_zone);
                    loadingShow();
                    let ip = await getUserIp()
                    console.log(ip)

                    let postData = {
                        zzm_yya_hqb: getAccessToken(),
                        aaa_off_csl: '111',
                    };

                    let headerParams = {
                        'ad-justad-id': localStorage.getItem("adjust_id"),
                        'ad-justad-j': '',
                        'ad-justad-idfv': '',
                    };

                    loadingShow();
                    getLoanInfo(postData, {
                        'bwd-irh-lnf': time_zone,
                        'xfo-plp-van': ip,
                        ...headerParams
                    }).then(res => {
                        console.log(res)
                        loadingHide()
                        this.isInfoLoading = false;
                        if(res.ci == 200){
                            let useData = res.da;
                            console.log(JSON.parse(useData))
                            if(useData){
                                let useDataJSON = JSON.parse(useData);
                                let {vkt_fnd_yzo, ojq_dzg_oxq } = useDataJSON;
                                //order_status, reapply_time, server_time current_is_reloan,
                                let { omi_fje_qly, huw_kdq_nxo, xhi_cur_ovl } = vkt_fnd_yzo;

                                console.log(omi_fje_qly);
                                console.log(huw_kdq_nxo);
                                console.log(ojq_dzg_oxq);
                                console.log(xhi_cur_ovl);

                                this.orderStatusNor = omi_fje_qly;
                                this.getStatus(omi_fje_qly, huw_kdq_nxo,  ojq_dzg_oxq, xhi_cur_ovl, _this);

                            }
                        } else {
                            Toast(res.ms);
                        }
                    }, error => {
                        loadingHide()
                        this.isInfoLoading = false;
                    });
                } else { //未登录
                    console.log('未登录1111')
                    this.$router.replace({
                        path: '/loanpage/loginhome'
                    })

                }
            },
            getStatus: (value, reapply_time, server_time, current_is_reloan, _this) => {
                switch (value) {
                    case 0:
                    case 10:
                    case 15:
                    case 17:
                    case 21:
                        console.log('0没有申请过,10失效,15展期结清,17展期失效,21等待签约');
                        _this.orderStatus = 2;
                        if(current_is_reloan != undefined){
                            if(current_is_reloan == 1){
                                _this.isReloan = 1;
                            } else {
                                _this.isReloan = null;
                            }
                        } else {
                            _this.isReloan = null;
                        }

                        if(_this.isReloan == 1){
                            _this.$router.replace({
                                path: '/loanpage/reapeatloan'
                            });
                        } else {
                            _this.$router.replace({
                                path: '/loanpage/applyhome'
                            });
                        }
                        break;
                    case 1:
                    case 2:
                    case 4:
                    case 13:
                    case 18:
                    case 19:
                    case 20:
                        console.log('//1提交申请,2提交审核,4等待人工审核,13等待第三方黑名单验证,18等待自动外呼,19等待人脸对比,20人工审核质检中');
                        _this.orderStatus = 1;
                        _this.loanStatus = 1;
                        _this.$router.replace({
                            path: '/loanpage/loanstatus'
                        });
                        break;
                    case 3:
                        console.log('//审核拒绝');
                        if (_this.canReloanByTime(reapply_time, server_time)) {
                            _this.orderStatus = 2;
                            /*if (_this.isReloan) {
                                if(current_is_reloan != undefined){
                                    if(current_is_reloan == 1){
                                        _this.isReloan = 1;
                                    } else {
                                        _this.isReloan = 1;
                                    }
                                } else {
                                    _this.isReloan = 1;
                                }
                                _this.$router.replace({
                                    path: '/loanpage/reapeatloan'
                                });
                            } else {

                            }*/

                            if(current_is_reloan != undefined){
                                if(current_is_reloan == 1){
                                    _this.isReloan = 1;
                                } else {
                                    _this.isReloan = null;
                                }
                            } else {
                                _this.isReloan = null;
                            }

                            if(_this.isReloan == 1){
                                _this.$router.replace({
                                    path: '/loanpage/reapeatloan'
                                });
                            } else {
                                _this.$router.replace({
                                    path: '/loanpage/applyhome'
                                });
                            }

                        } else {
                            _this.orderStatus = 1;
                            _this.loanStatus = 2;

                            _this.$router.replace({
                                path: '/loanpage/loanstatus'
                            });
                        }
                        break;
                    case 5:
                    case 12:
                        console.log('//5等待放款，12正在放款中');
                        _this.orderStatus = 1;
                        _this.loanStatus = 3;

                        _this.$router.replace({
                            path: '/loanpage/loanstatus'
                        });
                        break;
                    case 6:
                        console.log('//放款失败');
                        _this.orderStatus = 1;
                        _this.loanStatus = 4;

                        _this.$router.replace({
                            path: '/loanpage/loanstatus'
                        });
                        break;
                    case 7:
                    case 9:
                    case 11:
                    case 14:
                    case 16:
                        console.log('7等待还款，9逾期，11部分还款，14等待展期，16展期申请中');
                        _this.orderStatus = 3;

                        _this.$router.replace({
                            path: '/loanpage/repayment'
                        });
                        break;
                    case 8:
                        console.log('8已结清');
                        _this.orderStatus = 2;
                        if(current_is_reloan != undefined){
                            if(current_is_reloan == 1){
                                _this.isReloan = 1;
                            } else {
                                _this.isReloan = 1;
                            }
                        } else {
                            _this.isReloan = 1;
                        }
                        _this.$router.replace({
                            path: '/loanpage/reapeatloan'
                        });
                        break;
                    case 22:
                        console.log('22等待订单再次确认');
                        _this.orderStatus = 2;
                        if(current_is_reloan != undefined){
                            if(current_is_reloan == 1){
                                _this.isReloan = 1;
                            } else {
                                _this.isReloan = 0;
                            }
                        } else {
                            _this.isReloan = 0;
                        }

                        _this.$router.replace({
                            path: '/loanpage/firstloan'
                        });
                        break;
                    default:
                        _this.orderStatus = 2;
                        if(current_is_reloan != undefined){
                            if(current_is_reloan == 1){
                                _this.isReloan = 1;
                            } else {
                                _this.isReloan = null;
                            }
                        } else {
                            _this.isReloan = null;
                        }

                        if(_this.isReloan == 1){
                            _this.$router.replace({
                                path: '/loanpage/reapeatloan'
                            });
                        } else {
                            _this.$router.replace({
                                path: '/loanpage/applyhome'
                            });
                        }
                }
            },
            canReloanByTime(repTime, stime) {
                return repTime < stime;
            },
            onConfirm() {
                let bankoneval = this.bankoneval;
                let banktwoval = this.banktwoval;
                let bankthrval = this.bankthrval;

                if(bankoneval && bankoneval.id){
                    //if(banktwoval && banktwoval.id){
                    if(bankthrval && bankthrval.id){
                        let bankthrval_id = bankthrval.id;

                        if(bankthrval_id == 1){ //半月一次
                            let bankfivval = this.bankfivval;
                            let banksixval = this.banksixval;

                            if(bankfivval){
                                if(banksixval){

                                    let params = {
                                        monthly_income: bankoneval.id,
                                        income_source: '1',
                                        salary_type: bankthrval.id,
                                        salary_day: String(bankfivval),
                                        salary_day2: String(banksixval),
                                    }

                                    this.getCommomParams(params)

                                } else {
                                    Toast('Elige el segundo día de pago') //请选择第二个发薪日
                                }
                            } else {
                                Toast('Elige el primer día de pago') //请选择第一个发薪日
                            }

                        } else if(bankthrval_id == 2){ //每月一次
                            let bankfivval = this.bankfivval;
                            if(bankfivval){

                                let params = {
                                    monthly_income: bankoneval.id,
                                    income_source: '1',
                                    salary_type: bankthrval.id,
                                    salary_day: String(bankfivval),
                                }

                                this.getCommomParams(params)

                            } else {
                                Toast('Elige el día de pago') //请选择发薪日
                            }

                        } else if(bankthrval_id == 3){ //每周一次
                            let bankfurval = this.bankfurval;
                            if(bankfurval && bankfurval.id){

                                let params = {
                                    monthly_income: bankoneval.id,
                                    income_source: '1',
                                    salary_type: bankthrval.id,
                                    salary_day: bankfurval.id,
                                }

                                this.getCommomParams(params)

                            } else {
                                Toast('Elige el día de pago') //请选择发薪日
                            }
                        } else if(bankthrval_id == 4){ //双周
                            let bankfurval = this.bankfurval;
                            if(bankfurval && bankfurval.id){
                                let params = {
                                    monthly_income: bankoneval.id,
                                    income_source: '1',
                                    salary_type: bankthrval.id,
                                    salary_day: bankfurval.id,
                                }

                                this.getCommomParams(params)

                            } else {
                                Toast('Elige el día de pago') //请选择发薪日
                            }
                        }
                    } else {
                        Toast('Elige el método de pago') //请选择发薪方式
                    }
                    // } else {
                    //     Toast('请选择收入来源')
                    // }
                } else {
                    Toast('Elige el rango salarial') //请选择薪资范围
                }
            },
        }
    }
</script>

<style less scoped>
    .apply_banner{
        width: 100%;
        height: 1.45rem;
        box-sizing: border-box;
        padding: 0.25rem 0.277778rem 0 0.277778rem;
        position: relative;
    }
    .apply_head{
        width: 100%;
        height: 0.75rem;
        position: relative;
    }
    .apply_hview{
        width: 8.944444rem;
        height: 0.555556rem;
        position: absolute;
        left: 0.56rem;
        top: -0.611111rem;
    }
    .apply_hview img{
        display: block;
        width: 8.944444rem;
        height: 0.555556rem;
    }
    .apply_topview{
        width: 100%;
        height: 2.055556rem;
        box-sizing: border-box;
        padding: 0 0.555556rem;
    }
    .apply_top{
        width: 100%;
        height: 1.555556rem;
        box-sizing: border-box;
        padding: 0 0.5rem;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #DDF2E7;
        border-radius: 0.111111rem;
        font-size: 12px;
        font-weight: 400;
        color: #666666;
        line-height: 0.5rem;
    }
    .apply_formview{
        width: 100%;
        height: auto;
        box-sizing: border-box;
        padding: 0 0.555556rem;
    }
    .bank_conttop{
        width: 100%;
        height: auto;
    }
    .bank_ctitems{
        width: 100%;
        height: 1.472222rem;
    }
    .bank_ctitem{
        width: 100%;
        height: 1.111111rem;
        box-sizing: border-box;
        background: #ffffff;
        border-radius: 0.083333rem;
        border: 1px solid #DEE0E6;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .bank_ctitem_active{
        border: 1px solid #00CA88;
    }
    .bank_ctileft{
        width: auto;
        height: 14px;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        padding-left: 0.444444rem;
        font-size: 13px;
        font-weight: 500;
        color: #1A1A1A;
    }
    .bank_ctiright{
        width: auto;
        height: 8px;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        padding-right: 0.416667rem;
    }
    .bank_ctirview{
        width: 13px;
        height: 8px;
    }
    .bank_ctirview img{
        display: block;
        width: 13px;
        height: 8px;
    }
    .bank_ctiright_new{
        width: auto;
        height: 0.555556rem;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        padding-right: 0.277778rem;
    }
    .bank_ctirview_new{
        width: 0.555556rem;
        height: 0.555556rem;
    }
    .bank_ctirview_new img{
        display: block;
        width: 0.555556rem;
        height: 0.555556rem;
    }
    .bank_ctitem_active .bank_ctileft{
        color: #1A1A1A;
    }
    .bank_ctitem .bank_code{
        display: block;
        width: 90%;
        height: 0.8rem;
        outline: none;
        border: none;
        background: #ffffff;
        border-radius: 0.333333rem;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        padding-left: 0.444444rem;
        font-size: 13px;
        font-weight: 500;
        color: #1A1A1A;
    }
    .bank_ctitem_active .bank_code{
        color: #1A1A1A;
    }
    .bank_contmiddle{
        width: 100%;
        height: 1.611111rem;
        display: flex;
        justify-content: flex-start;
    }
    .bank_contmleft{
        width: 0.666667rem;
        height: 0.444444rem;
    }
    .bank_contmlview{
        width: 0.394444rem;
        height: 0.444444rem;
        margin-top: 2px;
    }
    .bank_contmlview img{
        display: block;
        width: 0.394444rem;
        height: 0.444444rem;
    }
    .bank_contmright{
        width: 7.888889rem;
        height: 1.0rem;
        display: flex;
        align-items: center;
    }
    .bank_contmright p{
        font-size: 0.333333rem;
        font-weight: 500;
        color: #999999;
    }
    .bank_contdown{
        width: 7.722222rem;
        height: 1.111111rem;
        margin: 0 auto;
    }


</style>

<style less>
    #applywork .van-action-sheet__description{
        background: #19A95C;
        color: #ffffff;
        font-size: 16px;
    }
    #applywork .van-action-sheet__cancel{
        color: #FB4840;
    }
    #applywork .van-action-sheet__item .van-action-sheet__name{
        color: #19A95C;
    }
    #applywork .van-popup--bottom.van-popup--round{
        border-radius: 8px 8px 0px 0px;
    }
    #applywork .van-calendar__popup.van-popup--bottom,
    #applywork .van-calendar__popup.van-popup--top{
        height: auto;
    }
    #applywork .van-calendar__header{
        background: #19A95C;
        color: #ffffff;
    }
    #applywork .van-calendar__weekdays{
        display: none;
    }
    #applywork .van-calendar__month-title{
        display: none;
    }
    #applywork .van-calendar__days{
        padding-top: 10px;
    }
    #applywork .van-calendar__day{
        height: 45px;
    }
    #applywork .van-calendar__selected-day{
        width: 30px;
        height: 30px;
        border-radius: 50%;
    }
    #applywork .van-dialog{
        width: 76.39vw;
        border-radius: 0.277778rem;
    }
    #applywork .van-dialog__confirm, .van-dialog__confirm:active{
        background: #19A95C;
    }
    #bank_fiv .van-calendar__month-title{
        display: none;
    }
    #bank_six .van-calendar__month-title{
        display: none;
    }
</style>